import { useTranslation } from 'react-i18next';

import { Popup2 } from 'libs/ui';
import { Uploader } from 'pages/options/soupload/uploader';

export const ImportForm = ({ close }) => {
  const { t } = useTranslation();

  const help =
    'Требуется файл csv содержащий 5 полей. Первая строка "type;name;fn;min_amount;amount", далее строки с данными скидок, например "check;Кафе;9885934789431111;1000;100"';

  return (
    <Popup2 w={482} close={close} title={t('form.Импорт скидок')} help={help}>
      <Uploader type="discounts" asModal />
    </Popup2>
  );
};

export default ImportForm;
